import { createAction, createAsyncAction } from 'typesafe-actions'
import { LastConfiguration, LastConfigurationAvailability } from '@avp/core'

export const setLastConfigurationsAvailabilities = createAction('DOC / LastConfigurationsAvailabilities / set')<LastConfigurationAvailability[]>()

export const setLastConfigurations = createAction('DOC / LastConfigurations / set')<LastConfiguration[]>()

export const setLastConfigurationsMerge = createAction('DOC / LastConfigurations / merge by date')<LastConfiguration[]>()

export const setLastConfigurationsLoadingDate = createAction('DOC / LastConfigurations / set loading date')<string | null>()

export const fetchLastConfigurationsInfo = createAction('CMD / LastConfigurationsInfo / fetch')()

export const fetchLastConfigurationsForDate = createAction('CMD / LastConfigurationsInfo / fetch for date')<string>()

export const fetchLastConfigurationsAvailabilitiesAsync = createAsyncAction(
    'EVT / LastConfigurationsAvailabilities / fetch request',
    'EVT / LastConfigurationsAvailabilities / fetch success',
    'EVT / LastConfigurationsAvailabilities / fetch failure',
)<undefined, { lastConfigurationsAvailabilities: LastConfigurationAvailability[] }, Error>()

export const fetchLastConfigurationsForDateAsync = createAsyncAction(
    'EVT / LastConfigurationsForDate / fetch request',
    'EVT / LastConfigurationsForDate / fetch success',
    'EVT / LastConfigurationsForDate / fetch failure',
)<undefined, { lastConfigurations: LastConfiguration[] }, Error>()
